export default __webpack_public_path__ + "static/media/undraw_detailed_analysis_re_tk6j.6786bc93.svg";